import React, { useEffect, useState } from 'react';
import {
    Box, Button, CircularProgress, InputBase, Typography, IconButton
} from "@mui/material";
import Intro from "../../atoms/Intro/Intro.component";
import { useParams, useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import { styled } from "@mui/material/styles";
import { DataGrid } from "@mui/x-data-grid";
import moment from "moment";
import { authHeader } from "../../../helpers";
import { apiConstants } from "../../../constants";
import { convertToPlaces } from "../../../helpers/helpers";
import VisibilityIcon from "@mui/icons-material/Visibility";

const useStyles = makeStyles({
    headerContainer: {
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
        padding: "5px 0 5px",
    },
    salesOrdersFilterBar: {
        margin: '14px 0px 16px',
        backgroundColor: '#EFEFEF',
        padding: '16px'
    },
});

const ResellerInvoices = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const [filterCustomerName, setFilterCustomerName] = useState('');
    const [filteredResults, setFilteredResults] = useState([]);
    const [response, setResponse] = useState('');
    const [loadingComponent, setLoadingComponent] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);

    const breadcrumbs = [
        <Typography key="3">
            Reseller Invoices
        </Typography>,
    ];

    useEffect(() => {
        setLoadingComponent(true);

        const requestOptions = {
            method: "GET",
            headers: authHeader(),
        };

        fetch(`${apiConstants.API_URL}/reseller-invoices`, requestOptions).then((response) => {
            response.text().then((text) => {
                const data = text && JSON.parse(text);
                setFilteredResults(data?.data);
                setResponse(data?.meta);
                setLoadingComponent(false);
            });
        });
    }, []);

    function handlePageChange(page) {
        setCurrentPage(page)
        const requestOptions = {
            method: "GET",
            headers: authHeader(),
        };
        let url;
        if (filterCustomerName !== '') {
            url = `${apiConstants.API_URL}/reseller-invoices?organization.name=${filterCustomerName}&page=${page + 1}`
        } else {
            url = `${apiConstants.API_URL}/reseller-invoices?page=${page + 1}`
        }

        fetch(url, requestOptions).then((response) => {
            response.text().then((text) => {
                const data = text && JSON.parse(text);
                setFilteredResults(data?.data);
                setResponse(data?.meta);
            });
        });
    }

    // Place columns inside the component to use navigate
    const columns = [
        {
            field: 'id',
            headerName: 'Reseller Invoice ID',
            resizable: false,
            width: 150,
        },
        {
            field: 'created_at',
            headerName: 'Date',
            width: 150,
            renderCell: params => moment(params.row.created_at).format('DD/MM/YYYY')
        },
        {
            field: 'organization_name',
            headerName: 'Organization name',
            resizable: false,
            width: 250,
        },
        {
            field: 'grand_total',
            headerName: 'Grand Total',
            sortable: true,
            width: 300,
            minWidth: 100,
            renderCell: params => convertToPlaces(params.row.grand_total)
        },
        {
            field: 'actions',
            headerName: 'Actions',
            width: 100,
            type: 'actions',
            renderCell: (params) => (
                <IconButton
                    onClick={() => navigate(`/admin/invoices/${params.row.id}/view`)}
                    color="primary"
                    aria-label="view invoice"
                >
                    <VisibilityIcon />
                </IconButton>
            ),
            resizable: false
        },
    ];

    return (
        <>
            <Box className={classes.headerContainer}>
                <Intro
                    pageTitle={"Reseller Invoices"}
                    pageTitleShort=""
                    breadcrumbs={breadcrumbs}
                    additionalWidgets=""
                />
            </Box>
            <Box style={{ width: '100%' }}>
                {loadingComponent ?
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
                        <CircularProgress size={50} />
                    </Box>
                    :
                    <DataGrid
                        autoHeight={true}
                        className={classes.dataGrid}
                        rows={filteredResults}
                        pageSize={response?.per_page}
                        pagination
                        getRowId={(row) => row.id}
                        rowCount={response?.total}
                        onPageChange={handlePageChange}
                        columns={columns}
                        paginationMode="server"
                    />
                }
            </Box>
        </>
    );
};

export default ResellerInvoices;
